import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption1SecondaryProps extends ITextBoxProps {}

export const TextBoxCaption1Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Caption1,
  maxLines = 1,
  ...rest
}: ITextBoxCaption1SecondaryProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    maxLines={maxLines}
    {...rest}
  />
)
